import React from "react";

export default ({ submit, input }) => {
  return (
    <div
      style={{
        backgroundColor: "white",
        marginLeft: "250px",
        paddingBottom: "400px",
      }}
    >
      <div
        className="container"
        style={{
          paddingLeft: "35px",
          paddingRight: "35px",
          paddingTop: "20px",
        }}
      >
        <h1 className="font-weight-bold">Create Hotel</h1>
        <div className="col">
          <form
            onSubmit={(e) => submit(e)}
            style={{
              padding: "40px",
              marginRight: "20px",
            }}
          >
            <div
              className="form-group"
              style={{
                paddingBottom: "20px",
              }}
            >
              <h3 className="font-weight-bold">General</h3>

              <label
                style={{
                  marginTop: "20px",
                }}
              >
                Name
              </label>
              <input
                onChange={(e) => input(e)}
                name="name"
                type="text"
                className="form-control"
                placeholder="Hotel name..."
                required
              />

              <label
                style={{
                  marginTop: "20px",
                }}
              >
                Mail
              </label>
              <input
                onChange={(e) => input(e)}
                name="mail"
                type="text"
                className="form-control"
                placeholder="hotel@lovable.solutions"
                required
              />

              <label
                style={{
                  marginTop: "20px",
                }}
              >
                Direction
              </label>
              <input
                onChange={(e) => input(e)}
                name="direction"
                type="text"
                className="form-control"
                placeholder="Direction..."
                required
              />

              <label
                style={{
                  marginTop: "20px",
                }}
              >
                Phone
              </label>
              <input
                onChange={(e) => input(e)}
                name="phone"
                type="text"
                className="form-control"
                placeholder="Phone..."
                required
              />

              <h3
                style={{
                  marginTop: "30px",
                }}
                className="font-weight-bold"
              >
                Logo & Color
              </h3>
              <label
                style={{
                  marginTop: "20px",
                }}
              >
                QR Mask
              </label>
              <input
                onChange={(e) => input(e)}
                name="qrMask"
                type="text"
                className="form-control"
                placeholder="Mask..."
                required
              />

              <label
                style={{
                  marginTop: "20px",
                }}
              >
                Logo Image
              </label>
              <input
                onChange={(e) => input(e)}
                name="logoImage"
                type="text"
                className="form-control"
                placeholder="URL Image"
                required
              />

              <label
                style={{
                  marginTop: "20px",
                }}
              >
                Primary Color
              </label>
              <input
                onChange={(e) => input(e)}
                name="primaryColor"
                type="text"
                className="form-control"
                placeholder="Color..."
                required
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              style={{
                backgroundColor: "#FF2068",
                borderColor: "#FF2068",
              }}
            >
              Create
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
